import type { ContentWindowApi } from '@canvas/frame-api-types';

let standaloneHost: ContentWindowApi | undefined;

export const getStandaloneHost = (): ContentWindowApi | undefined => standaloneHost;

export const installStandaloneHost = (host: ContentWindowApi): VoidFunction => {
  if (standaloneHost) {
    throw new Error('A standalone Canvas host is already mounted');
  }
  standaloneHost = host;
  return () => {
    if (standaloneHost === host) {
      standaloneHost = undefined;
    }
  };
};
